import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="asset"
export default class extends Controller {
  static outlets= ["map"]
  static values = {
    lat: Number,
    lng: Number,
    performImmediately: Boolean
  }

  connect() {
    if (this.performImmediatelyValue) this.center()
  }

  center(){
    this.mapOutlet.center(this.latValue, this.lngValue)
  }
}